// Shared, self-contained fallback avatar.
//
// Teacher/user photos previously fell back to an EXTERNAL placeholder
// (via.placeholder.com), which renders as a broken image whenever that host is
// slow, blocked, or offline. This inline SVG data-URI has no network dependency
// and always renders, so a profile without a photo shows a neutral silhouette
// instead of a broken-image icon.
const AVATAR_SVG = `<svg xmlns="http://www.w3.org/2000/svg" width="150" height="150" viewBox="0 0 150 150">
  <rect width="150" height="150" fill="#e5e7eb"/>
  <circle cx="75" cy="58" r="27" fill="#9ca3af"/>
  <path d="M28 132c0-26 21-41 47-41s47 15 47 41z" fill="#9ca3af"/>
</svg>`;

export const DEFAULT_AVATAR = `data:image/svg+xml,${encodeURIComponent(
  AVATAR_SVG
)}`;

// Resolve a usable avatar src, falling back to the inline default when a photo
// URL is missing/blank.
export const avatarSrc = (photoURL) => {
  const url = typeof photoURL === "string" ? photoURL.trim() : "";
  return url || DEFAULT_AVATAR;
};

// <img @error> handler: swap a photo that fails to load for the default avatar.
// Guards against an infinite error loop if the fallback itself ever failed.
export const onAvatarError = (event) => {
  const img = event && event.target;
  if (img && img.src !== DEFAULT_AVATAR) {
    img.src = DEFAULT_AVATAR;
  }
};
